import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import * as Constants from '../../Constant/constant';
import './BookList.css';
import Swal from 'sweetalert2';


const BookList = () => {
  const [books, setBooks] = useState([]);
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [userSearch, setUserSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [isBookIssued, setIsBookIssued] = useState(false); // NEW STATE
  const booksPerPage = 10;

  useEffect(() => {
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      const res = await fetch(`${Constants.API_PATH}/book_list`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setBooks(data);
      } else {
        console.error('book_list API did not return an array:', data);
        setBooks([]);
      }
    } catch (error) {
      console.error('Error fetching books:', error);
      setBooks([]);
    }
  };
    const openImagePopup = (img) => {
          Swal.fire({
            imageUrl: `https://libtest.jaipuriaschools.com/${img.replace(/\\/g, '/')}`,
            imageAlt: 'Book Image',
            showCloseButton: true,
            width: '600px'
          });
        };

  const handleOpenUserModal = async (book) => {
    setSelectedBook(book);
    setUserSearch('');
    try {
      const res = await fetch(`${Constants.API_PATH}/get-users-with-book-status?book_id=${book.id}&library_id=${book.library_id}`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setUsers(data);
        const isIssued = data.some(u => u.has_book); // CHECK IF BOOK ALREADY ISSUED
        setIsBookIssued(isIssued); // SET STATUS
        setShowUserModal(true);
      } else {
        console.error('API did not return array:', data);
        alert(data.error || 'Failed to load users');
        setUsers([]);
      }
    } catch (error) {
      console.error('Error loading user-book status', error);
      setUsers([]);
      alert('Something went wrong while fetching users');
    }
  };

  const handleIssueBook = async (user) => {
    if (!selectedBook) return;

    const payload = {
      book_id: selectedBook.id,
      user_id: user.id,
      issue_date: new Date().toISOString().split('T')[0],
      due_date: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    };

    try {
      const res = await fetch(`${Constants.API_PATH}/admin-issue-book`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      if (result.success) {
        alert(`✅ Book issued to ${user.first_name}`);
        setUsers(prevUsers =>
          prevUsers.map(u =>
            u.id === user.id ? { ...u, has_book: true } : u
          )
        );
        setIsBookIssued(true); // SET TO TRUE ON SUCCESS
        fetchBooks();
        window.location.reload();
      } else {
        alert('❌ Issue failed: ' + result.message);
      }
    } catch (error) {
      console.error("Issue error:", error);
    }
  };

  const handleReturnBook = async (user_id) => {
    if (!selectedBook) return;
    const confirm = window.confirm("Mark this book as returned?");
    if (!confirm) return;

    const payload = {
      book_id: selectedBook.id,
      user_id: user_id,
      return_date: new Date().toISOString().split('T')[0]
    };

    try {
      const res = await fetch(`${Constants.API_PATH}/return-book`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      if (result.success) {
        alert("✅ Book returned successfully");
        setUsers(prevUsers =>
          prevUsers.map(u =>
            u.id === user_id ? { ...u, has_book: false } : u
          )
        );
        setIsBookIssued(false); // RESET ON RETURN
        fetchBooks();
        window.location.reload();
      } else {
        alert("❌ Failed to return book: " + result.message);
      }
    } catch (error) {
      console.error("Return error:", error);
    }
  };

  const filteredBooks = books.filter(book =>
    [book.book_name, book.book_code, book.copy_code].some(field =>
      field?.toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);
  const totalPages = Math.ceil(filteredBooks.length / booksPerPage);

// ...existing code...
const handleDeleteBook = async (bookId) => {
  if (!window.confirm("Are you sure you want to delete this book?")) return;
  try {
    const res = await fetch(`${Constants.API_PATH}/delete_new_books/${bookId}`, {
      method: 'DELETE'
    });
    const result = await res.json();
    if (result.success) {
      alert("✅ Book deleted successfully");
      setBooks(prevBooks => prevBooks.filter(book => book.id !== bookId));
    } else {
      alert("❌ Failed to delete book: " + (result.message || "Unknown error"));
    }
  } catch (error) {
    alert("❌ Error deleting book");
  }
};
// ...existing code...





  return (
    <div className="add-book-type-container containernew mt-4">
      <div className="row">
        <div className='col-md-8'>
          <h2>📚 Book List</h2>
        </div>
        <div className='col-md-4'>
          <button className="btn btn-primary" onClick={() => window.location.href = "/add-new-book"}>➕ Add Book</button>
        </div>
      </div>
     

      <input
        type="text"
        className="form-control mb-3"
        placeholder="Search books..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <div className="table-responsive">
        <table className="table table-bordered table-hover text-center custom-table">
          <thead className="table-dark">
            <tr>
              <th>#</th>
               <th>ISBN Number</th>
              <th>Book Image</th>
              <th>Book Name</th>
              <th>Author</th>
              <th>Library</th>
              <th>Book Type</th>
              <th>Book Code</th>
              <th>Publisher</th>
              <th>Copies</th>
              {/* <th>Status</th> */}
              <th>Location</th>
              <th>Book Fine</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentBooks.map((book, i) => (
              <tr key={book.id}>
                <td>{indexOfFirstBook + i + 1}</td>
                <td>{book.isbn_no || 'N/A'}</td>
                <td>
                  {book.image ? (
                    <img
                      src={`https://libtest.jaipuriaschools.com/${book.image.replace(/\\/g, '/')}`}
                      alt={book.book_name}
                      onClick={() => openImagePopup(book.image)}
                      style={{ width: '50px', height: 'auto' }}
                    />
                  ) : (
                    <span>No Image</span>
                  )}
                </td>
                <td>{book.book_name}</td>
                <td>{book.author}</td>
                <td>{book.library_name}</td>
                <td>{book.book_type_name}</td>
                <td>{book.book_code}</td>
                <td>{book.publisher}</td>
                <td>{book.num_copies}</td>
                {/* <td>
                  {book.status === 0 ? 'New' :
                    book.status === 1 ? 'Issued' :
                      book.status === 2 ? 'Rejected' : 'Unknown'}
                </td> */}
                <td>{book.book_location}</td>
                <td>{book.book_fine}</td>

                <td>
                  <button className="btn btn-warning btn-sm" onClick={() => handleOpenUserModal(book)} disabled={book.status === 1 || book.has_book}>
                  {book.status === 1 || book.has_book ? "Issued" : "Issue Book"}
                  </button>
                  {/* <button
                    className="btn btn-danger btn-sm ms-2"
                    onClick={() => handleDeleteBook(book.id)}
                  >
                    Delete
                  </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <nav>
        <ul className="pagination justify-content-center">
          {Array.from({ length: totalPages }).map((_, i) => (
            <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
              <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
            </li>
          ))}
        </ul>
      </nav>

      {/* User Modal */}
      {showUserModal && (
        <div className="modal fade show d-block" style={{ background: 'rgba(0,0,0,0.4)' }}>
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Select User for "{selectedBook.book_name}"</h5>
                <button className="btn-close" onClick={() => setShowUserModal(false)}></button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Search user by name or email"
                  value={userSearch}
                  onChange={(e) => setUserSearch(e.target.value)}
                />
                <table className="table table-bordered custom-table">
                  <thead><tr><th>Name</th><th>Email</th><th>Unique ID</th><th>Action</th></tr></thead>
                  <tbody>
                    {users
                      .filter(user =>
                        user.first_name.toLowerCase().includes(userSearch.toLowerCase()) ||
                        user.email.toLowerCase().includes(userSearch.toLowerCase()) ||
                        user.unique_id?.toLowerCase().includes(userSearch.toLowerCase())
                      )
                      .map(user => (
                        <tr key={user.id}>
                          <td>{user.first_name}</td>
                          <td>{user.email}</td>
                          <td>{user.unique_id}</td>
                          <td>
                            {user.has_book ? (
                              <button className="btn btn-sm btn-danger" onClick={() => handleReturnBook(user.id)}>↩️ Return</button>
                            ) : (
                              <button className="btn btn-sm btn-success"
                                onClick={() => handleIssueBook(user)}
                                disabled={user.has_book || isBookIssued}
                              >
                                ✅ Issue
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowUserModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookList;
